import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { EmployeeDocumentType, IEmployeeDocument } from '../interfaces/employee-document.interface';

export const EmployeeDocumentService = {
    getMyDocuments: async (): Promise<IEmployeeDocument[]> => {
        const response = await axios.get(ENDPOINTS.EMPLOYEE_DOCUMENT.MY_DOCUMENTS, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    getDocumentsByUserId: async (userId: string): Promise<IEmployeeDocument[]> => {
        const response = await axios.get(ENDPOINTS.EMPLOYEE_DOCUMENT.BY_USER(userId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    uploadDocumentForUser: async (userId: string, documentType: EmployeeDocumentType, file: File): Promise<IEmployeeDocument> => {
        const institutionId = AuthService.getSelectedInstitution()!;
        const formData = new FormData();
        formData.append('documentType', documentType);
        formData.append('institutionId', institutionId);
        formData.append('file', file);
        const response = await axios.post(ENDPOINTS.EMPLOYEE_DOCUMENT.UPLOAD_FOR_USER(userId), formData, {
            headers: {
                ...AuthService.getAuthHeader(),
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    uploadDocument: async (documentType: EmployeeDocumentType, file: File): Promise<IEmployeeDocument> => {
        const institutionId = AuthService.getSelectedInstitution()!;
        const formData = new FormData();
        formData.append('documentType', documentType);
        formData.append('institutionId', institutionId);
        formData.append('file', file);

        const response = await axios.post(ENDPOINTS.EMPLOYEE_DOCUMENT.UPLOAD, formData, {
            headers: {
                ...AuthService.getAuthHeader(),
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    getDocumentBlobUrl: async (documentId: string): Promise<string> => {
        const response = await axios.get(ENDPOINTS.EMPLOYEE_DOCUMENT.DOWNLOAD(documentId), {
            headers: AuthService.getAuthHeader(),
            responseType: 'blob',
        });
        return window.URL.createObjectURL(new Blob([response.data]));
    },

    downloadDocument: async (documentId: string, fileName: string): Promise<void> => {
        const response = await axios.get(ENDPOINTS.EMPLOYEE_DOCUMENT.DOWNLOAD(documentId), {
            headers: AuthService.getAuthHeader(),
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
};
